import { render, staticRenderFns } from "./tree2.vue?vue&type=template&id=1bdf0549&scoped=true&"
import script from "./tree2.vue?vue&type=script&lang=js&"
export * from "./tree2.vue?vue&type=script&lang=js&"
import style0 from "./tree2.vue?vue&type=style&index=0&id=1bdf0549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf0549",
  null
  
)

export default component.exports